import React, { useEffect, useRef } from 'react';
export function SolutionSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, {
      threshold: 0.1
    });
    const reveals = sectionRef.current?.querySelectorAll('.reveal');
    reveals?.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);
  return <div ref={sectionRef} data-id="element-207">
      {/* WHY NOTHING WORKS */}
      <section className="py-20 px-4" style={{
      background: 'var(--color-cream)'
    }} data-id="element-208">
        <div className="max-w-4xl mx-auto" data-id="element-209">
          <div className="text-center mb-12" data-id="element-210">
            <h2 className="reveal font-playfair text-4xl md:text-5xl font-bold mb-4" style={{
            color: 'var(--color-dark)'
          }} data-id="element-211">
              ¿Por qué nada funciona?
            </h2>
            <p className="reveal reveal-delay-1 font-lato text-lg" style={{
            color: 'rgba(44, 24, 16, 0.65)'
          }} data-id="element-212">
              Has probado de todo. El problema no eres tú.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-10" data-id="element-213">
            {/* Pain point 1 */}
            <div className="reveal reveal-delay-1 flex items-start gap-4 rounded-2xl p-5" style={{
            background: 'var(--color-light)',
            border: '1px solid rgba(196, 113, 74, 0.15)'
          }} data-id="element-214">
              <span className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-black" style={{
              background: 'rgba(196, 113, 74, 0.15)',
              color: 'var(--color-terracotta)'
            }} data-id="element-215">
                ✕
              </span>
              <div data-id="element-216">
                <p className="font-lato font-bold text-sm mb-1" style={{
                color: 'var(--color-dark)'
              }} data-id="element-217">
                  Cremas baratas
                </p>
                <p className="font-lato text-sm" style={{
                color: 'rgba(44, 24, 16, 0.7)'
              }} data-id="element-218">
                  Solo hidratan la superficie. No penetran las capas profundas
                  donde está el problema.
                </p>
              </div>
            </div>

            {/* Pain point 2 */}
            <div className="reveal reveal-delay-2 flex items-start gap-4 rounded-2xl p-5" style={{
            background: 'var(--color-light)',
            border: '1px solid rgba(196, 113, 74, 0.15)'
          }} data-id="element-219">
              <span className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-black" style={{
              background: 'rgba(196, 113, 74, 0.15)',
              color: 'var(--color-terracotta)'
            }} data-id="element-220">
                ✕
              </span>
              <div data-id="element-221">
                <p className="font-lato font-bold text-sm mb-1" style={{
                color: 'var(--color-dark)'
              }} data-id="element-222">
                  10 pasos TikTok
                </p>
                <p className="font-lato text-sm" style={{
                color: 'rgba(44, 24, 16, 0.7)'
              }} data-id="element-223">
                  Imposibles con hijos, café y el metro. Nadie tiene 45 minutos
                  por la mañana.
                </p>
              </div>
            </div>

            {/* Pain point 3 */}
            <div className="reveal reveal-delay-1 flex items-start gap-4 rounded-2xl p-5" style={{
            background: 'var(--color-light)',
            border: '1px solid rgba(196, 113, 74, 0.15)'
          }} data-id="element-224">
              <span className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-black" style={{
              background: 'rgba(196, 113, 74, 0.15)',
              color: 'var(--color-terracotta)'
            }} data-id="element-225">
                ✕
              </span>
              <div data-id="element-226">
                <p className="font-lato font-bold text-sm mb-1" style={{
                color: 'var(--color-dark)'
              }} data-id="element-227">
                  Serums Amazon 60€
                </p>
                <p className="font-lato text-sm" style={{
                color: 'rgba(44, 24, 16, 0.7)'
              }} data-id="element-228">
                  Picazón, residuos blancos, cero relleno real. Dinero tirado
                  con promesas vacías.
                </p>
              </div>
            </div>

            {/* Pain point 4 */}
            <div className="reveal reveal-delay-2 flex items-start gap-4 rounded-2xl p-5" style={{
            background: 'var(--color-light)',
            border: '1px solid rgba(196, 113, 74, 0.15)'
          }} data-id="element-229">
              <span className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-black" style={{
              background: 'rgba(196, 113, 74, 0.15)',
              color: 'var(--color-terracotta)'
            }} data-id="element-230">
                ✕
              </span>
              <div data-id="element-231">
                <p className="font-lato font-bold text-sm mb-1" style={{
                color: 'var(--color-dark)'
              }} data-id="element-232">
                  Influencers de 25 años
                </p>
                <p className="font-lato text-sm" style={{
                color: 'rgba(44, 24, 16, 0.7)'
              }} data-id="element-233">
                  Rutinas eternas con ingredientes que no encuentras ni en
                  Carrefour. No es tu realidad.
                </p>
              </div>
            </div>

            {/* Pain point 5 - full width */}
            <div className="reveal reveal-delay-3 flex items-start gap-4 rounded-2xl p-5 md:col-span-2" style={{
            background: 'var(--color-light)',
            border: '1px solid rgba(196, 113, 74, 0.15)'
          }} data-id="element-234">
              <span className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-black" style={{
              background: 'rgba(196, 113, 74, 0.15)',
              color: 'var(--color-terracotta)'
            }} data-id="element-235">
                ✕
              </span>
              <div data-id="element-236">
                <p className="font-lato font-bold text-sm mb-1" style={{
                color: 'var(--color-dark)'
              }} data-id="element-237">
                  Mantenimiento errático
                </p>
                <p className="font-lato text-sm" style={{
                color: 'rgba(44, 24, 16, 0.7)'
              }} data-id="element-238">
                  Progreso día 4, regresión día 14. Sin estructura clara, el
                  cuerpo no puede regenerar.
                </p>
              </div>
            </div>
          </div>

          {/* Transition callout */}
          <div className="reveal rounded-2xl p-6 text-center" style={{
          background: 'linear-gradient(135deg, rgba(44, 24, 16, 0.06), rgba(212, 168, 83, 0.08))',
          border: '2px solid rgba(212, 168, 83, 0.3)'
        }} data-id="element-239">
            <p className="font-playfair text-lg md:text-xl font-bold" style={{
            color: 'var(--color-dark)'
          }} data-id="element-240">
              Fallas porque tratas síntomas, no la causa:{' '}
              <span style={{
              color: 'var(--color-terracotta)'
            }} data-id="element-241">
                colágeno colapsado sin "mensajeros" regeneradores.
              </span>
            </p>
          </div>
        </div>
      </section>

      {/* THE SOLUTION */}
      <section className="py-20 px-4" style={{
      background: 'linear-gradient(135deg, #EDD9B0 0%, #F5EDD8 40%, #E8C47A 100%)'
    }} data-id="element-242">
        <div className="max-w-5xl mx-auto" data-id="element-243">
          {/* Badge */}
          <div className="text-center mb-8" data-id="element-244">
            <span className="reveal inline-block font-lato font-black text-sm px-5 py-2 rounded-full uppercase tracking-widest mb-6" style={{
            background: 'var(--color-olive)',
            color: 'var(--color-cream)'
          }} data-id="element-245">
              La Solución
            </span>
            <h2 className="reveal reveal-delay-1 font-playfair text-4xl md:text-6xl font-bold mb-4" style={{
            color: 'var(--color-dark)'
          }} data-id="element-246">
              Protocolo Exosome Express
            </h2>
            <p className="reveal reveal-delay-2 font-lato text-lg max-w-2xl mx-auto leading-relaxed" style={{
            color: 'rgba(44, 24, 16, 0.75)'
          }} data-id="element-247">
              Los exosomas clínicos (500€/sesión) envían "paquetes celulares"
              que reparan colágeno profundo. Aquí lo{' '}
              <strong data-id="element-248">hackeamos con aloe + miel + oliva de Mercadona.</strong>
            </p>
          </div>

          {/* Feature pills */}
          <div className="reveal reveal-delay-3 flex flex-wrap justify-center gap-3 mb-10" data-id="element-249">
            <span className="font-lato font-bold text-sm px-5 py-3 rounded-full" style={{
            background: 'rgba(44, 24, 16, 0.08)',
            color: 'var(--color-dark)',
            border: '1px solid rgba(44, 24, 16, 0.15)'
          }} data-id="element-250">
              🧬 Liposomas naturales
            </span>
            <span className="font-lato font-bold text-sm px-5 py-3 rounded-full" style={{
            background: 'rgba(44, 24, 16, 0.08)',
            color: 'var(--color-dark)',
            border: '1px solid rgba(44, 24, 16, 0.15)'
          }} data-id="element-251">
              🔬 Penetración profunda 40+
            </span>
            <span className="font-lato font-bold text-sm px-5 py-3 rounded-full" style={{
            background: 'rgba(44, 24, 16, 0.08)',
            color: 'var(--color-dark)',
            border: '1px solid rgba(44, 24, 16, 0.15)'
          }} data-id="element-252">
              ☀️🌙 4 pasos AM/PM
            </span>
            <span className="font-lato font-bold text-sm px-5 py-3 rounded-full" style={{
            background: 'rgba(44, 24, 16, 0.08)',
            color: 'var(--color-dark)',
            border: '1px solid rgba(44, 24, 16, 0.15)'
          }} data-id="element-253">
              ⏱️ 5-7 minutos
            </span>
          </div>

          {/* Result callout */}
          <div className="reveal rounded-3xl p-8 text-center mb-12" style={{
          background: 'rgba(44, 24, 16, 0.85)',
          border: '2px solid var(--color-gold)',
          boxShadow: '0 0 40px rgba(212, 168, 83, 0.2)'
        }} data-id="element-254">
            <p className="font-playfair text-2xl md:text-3xl font-bold mb-2" style={{
            color: 'var(--color-gold)'
          }} data-id="element-255">
              Resultados día 4:
            </p>
            <p className="font-playfair text-3xl md:text-4xl font-black" style={{
            color: 'var(--color-cream)'
          }} data-id="element-256">
              arrugas rellenadas 20-40%
            </p>
            <p className="font-lato text-sm mt-3" style={{
            color: 'rgba(253, 248, 240, 0.6)'
          }} data-id="element-257">
              Accesible, rápido, sostenible. Glow español auténtico.
            </p>
          </div>

          {/* Ingredients */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-258">
            <div className="reveal reveal-delay-1 rounded-2xl p-6 text-center" style={{
            background: 'rgba(253, 248, 240, 0.7)',
            border: '1px solid rgba(212, 168, 83, 0.3)',
            backdropFilter: 'blur(8px)'
          }} data-id="element-259">
              <div className="text-5xl mb-4" data-id="element-260">🌿</div>
              <h3 className="font-playfair text-xl font-bold mb-2" style={{
              color: 'var(--color-dark)'
            }} data-id="element-261">
                Aloe Vera
              </h3>
              <p className="font-lato text-sm" style={{
              color: 'rgba(44, 24, 16, 0.7)'
            }} data-id="element-262">
                Base liposomal natural. Transporta activos a capas profundas de
                la dermis.
              </p>
            </div>

            <div className="reveal reveal-delay-2 rounded-2xl p-6 text-center" style={{
            background: 'rgba(253, 248, 240, 0.7)',
            border: '1px solid rgba(212, 168, 83, 0.3)',
            backdropFilter: 'blur(8px)'
          }} data-id="element-263">
              <div className="text-5xl mb-4" data-id="element-264">🍯</div>
              <h3 className="font-playfair text-xl font-bold mb-2" style={{
              color: 'var(--color-dark)'
            }} data-id="element-265">
                Miel
              </h3>
              <p className="font-lato text-sm" style={{
              color: 'rgba(44, 24, 16, 0.7)'
            }} data-id="element-266">
                Mensajero regenerador. Estimula la síntesis de colágeno y
                elastina.
              </p>
            </div>

            <div className="reveal reveal-delay-3 rounded-2xl p-6 text-center" style={{
            background: 'rgba(253, 248, 240, 0.7)',
            border: '1px solid rgba(212, 168, 83, 0.3)',
            backdropFilter: 'blur(8px)'
          }} data-id="element-267">
              <div className="text-5xl mb-4" data-id="element-268">🫒</div>
              <h3 className="font-playfair text-xl font-bold mb-2" style={{
              color: 'var(--color-dark)'
            }} data-id="element-269">
                Aceite de Oliva
              </h3>
              <p className="font-lato text-sm" style={{
              color: 'rgba(44, 24, 16, 0.7)'
            }} data-id="element-270">
                Escualeno mediterráneo. Sella la hidratación y aporta firmeza
                duradera.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
}